// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiCircularProgress-root {
    color: hsl(81.43deg 69.37% 43.53%) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AdminDataGrid/AdminDataGrid.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD","sourcesContent":[".MuiCircularProgress-root {\n    color: hsl(81.43deg 69.37% 43.53%) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
